<template>
  <div>
    <!-- <nav-header></nav-header> -->
    <router-view></router-view>
    <nav-footer
      :email="this.email"
      :phone="this.phone"
      :name="this.name"
      :addr="this.addr"
      :icp="this.icp"
    ></nav-footer>
  </div>
</template>

<script>
import NavFooter from "./../components/NavFooter";
export default {
  name: "home",
  components: {
    NavFooter,
  },
  data() {
    return {
      email: "域名： bjchiyue.com.cn",
      phone: "电话：010-52902280",
      icp : '备案号：京ICP备18007755号',
      name: "北京驰悦网络科技有限公司",
      addr: "地址：北京市朝阳区北苑路甲13号院2号楼16层2-1605",
    };
  },
};
</script>
<style lang="" scoped></style>
